export const chats = {
  chatListChatIfoAttachmentsText: 'Příloha(y) odeslána',
  chatListChatNoMessagesText: 'Zatím žádné zprávy',
  chatArchivedTitle: 'Archivované chaty',
  chatsCreatePrivateCurtainTitle: 'Nový chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Hledat',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Vytvořit',
  chatCreateButtonTitle: 'Další',
  chatCreateNewGroupHeader: 'Nová skupina',
  chatGroupNameInputTitle: 'Název skupiny',
  chatLogoTitle: 'Upravit',
  chatCreateGroupButtonTitle: 'Vytvořit skupinu',
  chatRequiredFieldsAlert: 'Musíte uvést název skupiny!',
  chatsCreateGroupChatLongTitleAlertText: 'Prosím, použijte kratší název!',
  chatsCreateGroupChatLBigImageAlertText: 'Prosím, zvolte menší obrázek!',
  chatsNewChatInputPlaceholder: 'Napište zprávu',
  chatsNewChatAddedBigImageAlertText: 'Prosím, zvolte menší obrázek!',
  chatOwnersArchiveOptionText: 'Archivovat',
  chatOwnersEditGroupOptionText: 'Upravit',
  chatOwnersManageGroupOptionText: 'Spravovat členy',
  chatOwnersChangeGroupOptionText: 'Změnit vlastníka skupiny',
  chatOwnersLeaveGroupOptionText: 'Opustit',
  chatOwnersDeleteGroupOptionText: 'Smazat chat',
  chatpopupArchivedTitle: 'Archivovat chat',
  chatpopupArchivedDescription: 'Jste si jisti?',
  chatArchiveGroupButtonTitleYes: 'Potvrdit',
  chatArchiveGroupButtonTitleCancel: 'Zrušit',
  chatEditGroupHeader: 'Upravit chat',
  chatEditGroupEditLogoTitle: 'Upravit',
  chatEditGroupButtonTitle: 'Uložit',
  chatGroupEditAlertText: 'Uložení úspěšné!',
  chatManageGroupHeader: 'Spravovat',
  chatManageGroupButtonTitle: 'Přidat člena',
  chatManageGroupSaveButtonTitle: 'Uložit',
  chatAddUsersGroupHeader: 'Přidat členy',
  chatAddUsersGroupButtonTitle: 'Potvrdit',
  chatAddUsersGroupSearchInputPlaceholder: 'Hledat',
  chatOwnershipTransferHeader: 'Převést vlastnictví',
  chatOwnershipTransferSearchInputPlaceholder: 'Hledat',
  chatOwnershipTransferButtonTitle: 'Potvrdit',
  chatOwnerMarkText: '(vy)',
  chatOwnershipTransferAlertText: 'Vlastnictví přeneseno!',
  chatOwnerLeaveGroupTitle: 'Opustit skupinu',
  chatOwnerLeaveGroupDescription: 'Jste vlastníkem chatu, takže musíte před odchodem zvolit nového vlastníka.',
  chatOwnerLeaveGroupButtonTitleYes: 'Vybrat',
  chatOwnerLeaveGroupButtonTitleNo: 'Zrušit',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archivovat',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Členové chatu',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Opustit',
  chatsGroupChatMemberCurtainTitle: 'Členové chatu',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Hledat',
  chatsGroupChatMemberCurtainOwnerMarkText: '(vlastník)',
  chatsGroupChatLeavePopupTitle: 'Opustit',
  chatsGroupChatLeavePopupText: 'Jste si jisti?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Zrušit',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Potvrdit',
  chatDeleteGroupTitle: 'Smazat chat',
  chatDeleteGroupDescription: 'Chat a jeho historie budou smazány pro všechny účastníky. Pokračovat?',
  chatDeleteGroupButtonTitleYes: 'Potvrdit',
  chatDeleteGroupButtonTitleNo: 'Zrušit',
  chatsPrivateChatCurtainArchOptionTitle: 'Archivovat',
  chatsEditMessage: 'Upravit zprávu',
  chatsCopyMessage: 'Kopírovat zprávu',
  chatsDeleteMessage: 'Smazat zprávu',
  chatsSelectMessage: 'Vybrat zprávu',
  chatMarkTextEdit: '(upraveno)',
  chatCopyMessageAlertText: 'Zpráva zkopírována!',
  chatDeleteMessageTitle: 'Smazat zprávu',
  chatDeleteMessageDescription: 'Smazat tuto zprávu?',
  chatDeleteMessageButtonTitleYes: 'Potvrdit',
  chatDeleteMessageButtonTitleNo: 'Zrušit',
  chatSelectButtonDelete: 'Zrušit',
  chatSelectButtonNo: 'Smazat',
  chatDeleteMessagesTitle: 'Smazat zprávy',
  chatDeleteMessagesDescription: 'Smazat tyto zprávy?',
  chatDeleteMessagesButtonTitleYes: 'Potvrdit',
  chatDeleteMessagesButtonTitleNo: 'Zrušit',
  chatArchiveButtonRestore: 'Obnovit',
  chatArchiveButtonNo: 'Smazat',
  chatNoUsersCurtainTitle: 'Chyba!',
  chatsNoUsersCurtainText: 'Zdá se, že nejsou žádní uživatelé kromě vás. Pozvěte přátele a začněte chatovat.',
  chatsNoUsersCurtainCancelButtonTitle: 'Zrušit',
  chatsNoUsersCurtainCopyButtonTitle: 'Kopírovat odkaz na aplikaci',
  chatsAppLinkCopiedAlertText: 'Odkaz zkopírován!',
  chatsTooFewUsers: 'Vyberte prosím alespoň jednoho uživatele, se kterým chcete chatovat!',
  chatsError: 'Něco se pokazilo!'
}
